import React from "react";
import { Observable } from "rxjs";
import { useObservable } from "../useObservable";

type FromObservableProp<T extends unknown> = {
  $: Observable<T>;
  children?: (value: T | null) => React.ReactNode | null | undefined | false;
  init?: T;
};

export const FromObservable = <T extends unknown>({ $, children, init }: FromObservableProp<T>) => {
  const value = useObservable($, init || null);
  return children && typeof children === "function" ? children(value) || null : null;
};
